var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-swipe',{staticClass:"swipes",attrs:{"show-indicators":_vm.showIndicators,"autoplay":3000},on:{"change":_vm.onChange}},_vm._l((_vm.banner),function(image,index){return _c('van-swipe-item',{key:index},[_c('div',{staticClass:"pageBannarShadow kimg"},[_c('img',{class:{unCurrent: index !== _vm.current},attrs:{"src":image}})])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }